<!-- AdminMenu.vue -->
<template>
  <div v-if="showOptions">
    <!-- Club block -->
    <div
      class="item"
      id="club"
      @click="onClubClick"
      :class="{ active: activePage === 'club' }"
    >
      <p class="name">{{ club.name }}</p>
    </div>

    <!-- Static submenu -->
    <div class="item">
      <div class="submenu">
        <MenuItem
          label="titles.uniforms"
          :active="activePage === 'uniforms'"
          @click="$emit('redirect', {routeName: 'uniforms'})"
        />
        <MenuItem
          v-if="!integra && event && parseInt(event.type_id) != 17"
          label="titles.payments_and_budget"
          :active="activePage === 'club-payments'"
          @click="$emit('redirect', {routeName: 'club-payments'})"
        />
      </div>
    </div>

    <!-- Dynamic team groups -->
    <template>
      <div
       v-for="(group, catKey) in categories"
       :key="catKey"
     >
       <TeamMenuGroup
         v-for="(team, teamId) in group"
         :key="teamId"
         :user="user"
         :team="team"
         :teamKey="teamId"
         :event="event"
         :activePage="activePage"
         :selectedTeam="selectedTeam"
         @redirect="$emit('redirect', $event)"
         @collapse="$emit('collapse', $event)"
         @changeTeam="$emit('changeTeam', teamId)"
       >
      </TeamMenuGroup>
     </div>
    </template>

    <!-- Documents and static options -->
    <RuleItem
      v-if="showRules"
      label="rules_doc"
      @click="$emit('openRules')"
    />
    <RuleItem
      v-if="showGroups || showCalendar"
      label="titles.tournament_competition_system"
      @click="$emit('openCompetitionSystem')"
    />
    <RuleItem
      v-if="showGroups"
      label="titles.tournament_file_groups"
      @click="$emit('openGroups')"
    />
    <RuleItem
      v-if="showCalendar"
      label="titles.tournament_file_groups_calendar"
      @click="$emit('openCalendar')"
    />
    <RuleItem
      v-if="showProtocolChildren"
      label="titles.volunteer_protocol_children"
      @click="$emit('openProtocolChildren')"
    />
  </div>
</template>

<script>
import MenuItem from '@/components/domain/home/left-menu/MenuItem.vue'
import RuleItem from '@/components/domain/home/left-menu/RuleItem.vue'
import TeamMenuGroup from '@/components/domain/home/left-menu/TeamMenuGroup.vue'

export default {
  name: 'AdminMenu',
  components: {
    MenuItem,
    RuleItem,
    TeamMenuGroup
  },
  props: {
    user: Object,
    club: Object,
    categories: Object,
    event: Object,
    activePage: String,
    selectedTeam: String,
    integra: Boolean,
    showOptions: Boolean
  },
  computed: {
    showRules () {
      return [].includes(parseInt(this.event.type_id))
    },
    showGroups () {
      return [].includes(parseInt(this.event.type_id)) && !this.integra
    },
    showCalendar () {
      return [].includes(parseInt(this.event.type_id)) && !this.integra
    },
    showProtocolChildren () {
      return parseInt(this.event.type_id) === 1 || parseInt(this.event.type_id) === 17
    }
  },
  methods: {
    onClubClick () {
      // first collapse every category
      this.$emit('collapse', '')
      // then navigate to Club
      this.$emit('redirect', { routeName: 'club' })
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
